import { cn } from "@/lib/tailwind"
import Image from "next/image"

export function Logo({ className }: { className?: string }) {
  return (
    <div>
      <Image src="/logo.svg" alt="logo" width={300} height={120} className={cn("block dark:invert", className)} />
    </div>
  )
}
